import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useCertificationsStore } from '../../../Store/hooks/useStore'

import { CertificationShowModalButtonProps } from './interface'

export const CertificationShowModalButton = ({
  disabled,
  data
}: CertificationShowModalButtonProps) => {
  const { toggleCertificationFormVisible, setCurrentCertification } =
    useCertificationsStore(state =>
      pick(state, ['toggleCertificationFormVisible', 'setCurrentCertification'])
    )

  const onClick = () => {
    toggleCertificationFormVisible()
    setCurrentCertification(data)
  }

  return (
    <Button type='link' onClick={onClick}>
      {disabled ? '查看' : '编辑'}
    </Button>
  )
}
